import React from "react"
import { FunctionComponent, useContext, useEffect, useState} from "react";
import clsx from "clsx";

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

//Custom components
import MapContext from "@/components/Map/MapContext";
import makeMUIControlStyle from "../makeMUIControlStyle";
import 'ol-ext/dist/ol-ext.css';
import ButtonControl from "../OpenLayersExt/ButtonControl";
//Types
import { MapContextType } from "@/@types/context/MapContext";
import { useTranslation } from "react-i18next";
import SnackbarContext from "@/ui/SnackbarContext/SnackbarContext";
import DialogContext from "@/ui/DialogContext/DialogContext";

import ExportMapDialog from "@/ui/Dialog/ExportMapDialog"
import { DialogContextType } from "@/@types/ui/DialogContext";

export interface IPrintControl {
  id?: string
  tooltip: string
  className: string
  target?: HTMLElement
  dpi?: number
  handleClick?: () => void
}

const PrintControl: FunctionComponent<IPrintControl> = (props) => {
  const [ready, setReady] = useState(false);

  const classes = makeMUIControlStyle();

  const mapContext = useContext<MapContextType | null>(MapContext);
  const snackbarContext = useContext(SnackbarContext)
  const { t } = useTranslation();
  const dialogContext = useContext<DialogContextType>(DialogContext);

  const { target, className, tooltip } = props; 

  const handleDialogClose = () => {

  }

  const handleOpenDialog = () => {
    dialogContext.showDialog(ExportMapDialog, {
      onClose: handleDialogClose,
      handleDownloadMap: handleDownloadMap
    });
  };

  const handleDownloadMap = (format: string, name: string) => {
    switch(format){
      case "png":
        downloadMapImage(name)
        break;
      case "pdf": 
        handleExportPDF(name)
    }
  }

  async function handleExportPDF(filename:string) {
    const map = mapContext?.map
    if(map == null) return;

    //@ts-ignore
    const baseLayerArray = map.getLayers().getArray()[0].getLayers().getArray()
  
    const activeBaseLayer = baseLayerArray.find((layer:any) => {
      return layer.getVisible() === true
    }).get('title')
    console.log(activeBaseLayer)
    if (activeBaseLayer !== 'OSM') {
      snackbarContext.showNotification("Izvoz karte u PDF moguć je samo za OSM podlogu", "error");
      return
    }

    const image = await generateImageSection(map)

    const documentDefinition = {
      content: [image],
      pageOrientation: 'landscape',

    }

    //@ts-ignore
    pdfMake.createPdf(documentDefinition).download(filename);
  
      
  }
  
  function downloadMapImage(filename: string) {
    
    if(mapContext?.map == null) return;

     //@ts-ignore
     const baseLayerArray = mapContext.map.getLayers().getArray()[0].getLayers().getArray()
  
     const activeBaseLayer = baseLayerArray.find((layer:any) => {
       return layer.getVisible() === true
     }).get('title')
     console.log(activeBaseLayer)
     if (activeBaseLayer !== 'OSM') {
       snackbarContext.showNotification("Izvoz karte moguć je samo za OSM podlogu", "error");
       return
     }

    generateImageSection(mapContext.map, 'png')
      .then((imageDataUrl) => {
        
        const link = document.createElement('a');
        link.href = imageDataUrl as any;
        link.download = filename +'.png'; 
        link.style.display = 'none';
  
        document.body.appendChild(link);
        link.click();
  
        document.body.removeChild(link);
      })
      .catch((error) => {
        console.error('Error generating or downloading the map image:', error);
      });
  }
 

  useEffect(() => {
    if (!ready) {
      if (mapContext && mapContext?.map !== null) {
        setReady(true);
      }
    }
  }, [mapContext?.map]);


  return ready ? (
      <ButtonControl
        id="print-btn"
        className={clsx(classes.control, className)}
        title={tooltip}
        html={`<i class="fas fa-print"></i>`}
        handleClick={handleOpenDialog}
        target={target}
      />
  ) : null;
};

export default PrintControl;

function generateImageSection(map:any, format="pdf") {
  return new Promise((resolve, reject) => {
      map.once('rendercomplete', function () {
          const mapCanvas = document.createElement('canvas');
          const size = map.getSize();
          mapCanvas.width = size[0];
          mapCanvas.height = size[1];
          const map2dContext = mapCanvas.getContext('2d');
          if(map2dContext == null) return;
          Array.prototype.forEach.call(
            map.getViewport().querySelectorAll('.ol-layer canvas, canvas.ol-layer'),
            function (canvas) {
              if (canvas.width > 0) {
                const opacity =
                  canvas.parentNode.style.opacity || canvas.style.opacity;
                map2dContext.globalAlpha = opacity === '' ? 1 : Number(opacity);
                let matrix;
                const transform = canvas.style.transform;
                if (transform) {
                  // Get the transform parameters from the style's transform matrix
                  matrix = transform
                    .match(/^matrix\(([^\(]*)\)$/)[1]
                    .split(',')
                    .map(Number);
                } else {
                  matrix = [
                    parseFloat(canvas.style.width) / canvas.width,
                    0,
                    0,
                    parseFloat(canvas.style.height) / canvas.height,
                    0,
                    0,
                  ];
                }
                // Apply the transform to the export map context
                CanvasRenderingContext2D.prototype.setTransform.apply(
                  map2dContext,
                  matrix
                );
                const backgroundColor = canvas.parentNode.style.backgroundColor;
                if (backgroundColor) {
                  map2dContext.fillStyle = backgroundColor;
                  map2dContext.fillRect(0, 0, canvas.width, canvas.height);
                }
                map2dContext.drawImage(canvas, 0, 0);
              }
            }
          );
          map2dContext.globalAlpha = 1;
          map2dContext.setTransform(1, 0, 0, 1, 0, 0);
          
          if(format == "pdf"){

            const image = mapCanvas.toDataURL();
            
            const imageSection = {
              image: image,
              alignment: 'center',
              width: 842,
              //style: 'image',
            }
            
            resolve(imageSection)
          }else{
            const image = mapCanvas.toDataURL(`image/${format}`);
            resolve(image);
          }
        });
  
        map.renderSync();

  })
}